import { Typography } from "@mui/material";

export const NotFound404: React.FC = () => {
  return (
    <Typography sx={{ m: 5 }}>
      404: The page you are looking for cannot be found.
    </Typography>
  );
};
